<div>
    <p-table [value]="producoes" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
        [rowsPerPageOptions]="[20, 50, 100]" [loading]="loading"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true"
        #dt [globalFilterFields]="['empresa','filial','material','descricaoMaterial','centroCusto','statusIntegracao','mensagemIntegracao']">
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between flex-wrap gap-2">
            <div class="flex align-items-center gap-2">
              <span class="text-900 font-semibold">{{ totalRecords }} Registros</span>
            </div>
            <div class="flex align-items-center gap-2">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar..." />
              </span>
              <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary" (onClick)="carregarDados()" pTooltip="Atualizar" tooltipPosition="top" [loading]="loading"></p-button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="min-width: 50px; text-align: center;">Detalhes</th>
            <th pSortableColumn="empresa" style="min-width: 100px;">Empresa <p-sortIcon field="empresa"></p-sortIcon></th>
            <th pSortableColumn="filial" style="min-width: 90px;">Filial <p-sortIcon field="filial"></p-sortIcon></th>
            <th pSortableColumn="dataReferencia" style="min-width: 130px;">Data Referência <p-sortIcon field="dataReferencia"></p-sortIcon></th>
            <th pSortableColumn="material" style="min-width: 120px;">Material <p-sortIcon field="material"></p-sortIcon></th>
            <th pSortableColumn="descricaoMaterial" style="min-width: 200px;">Descrição Material <p-sortIcon field="descricaoMaterial"></p-sortIcon></th>
            <th pSortableColumn="centroCusto" style="min-width: 120px;">Centro Custo <p-sortIcon field="centroCusto"></p-sortIcon></th>
            <th pSortableColumn="unidade" style="min-width: 100px;">Unidade <p-sortIcon field="unidade"></p-sortIcon></th>
            <th pSortableColumn="quantidadeProduzida" style="min-width: 120px; text-align: right;">Qtd Produzida <p-sortIcon field="quantidadeProduzida"></p-sortIcon></th>
            <th pSortableColumn="dataRecebimento" style="min-width: 150px;">Dt. Recebido <p-sortIcon field="dataRecebimento"></p-sortIcon></th>
            <th pSortableColumn="statusIntegracao" style="min-width: 140px;">Status <p-sortIcon field="statusIntegracao"></p-sortIcon></th>
            <th pSortableColumn="dataIntegracao" style="min-width: 150px;">Dt. Integ. ERP <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
            <th pSortableColumn="mensagemIntegracao" style="min-width: 200px;">Mensagem <p-sortIcon field="mensagemIntegracao"></p-sortIcon></th>
            <th pSortableColumn="dataUltimaAtualizacao" style="min-width: 150px;">Últ. Atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-producao>
          <tr>
            <td style="text-align: center;">
              <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="info" (onClick)="showDetalhes(producao)" pTooltip="Ver detalhes" tooltipPosition="top"></p-button>
            </td>
            <td><span class="font-semibold text-900">{{ producao.empresa }}</span></td>
            <td>{{ producao.filial }}</td>
            <td>{{ producao.dataReferencia }}</td>
            <td><code class="text-sm surface-ground border-round px-2 py-1">{{ producao.material }}</code></td>
            <td>{{ producao.descricaoMaterial }}</td>
            <td><code class="text-sm surface-ground border-round px-2 py-1">{{ producao.centroCusto }}</code></td>
            <td>{{ producao.unidade }}</td>
            <td style="text-align: right;">
              <span class="font-semibold">{{ producao.quantidadeProduzida?.toLocaleString("pt-BR") }}</span>
            </td>
            <td>{{ producao.dataRecebimento }}</td>
            <td><app-tag-status [status]="producao.statusIntegracao"></app-tag-status></td>
            <td>{{ producao.dataIntegracao }}</td>
            <td>
              <span *ngIf="producao.mensagemIntegracao" class="text-700 text-sm" [pTooltip]="producao.mensagemIntegracao" tooltipPosition="top">
                {{ producao.mensagemIntegracao.length > 40 ? (producao.mensagemIntegracao | slice:0:40) + '...' : producao.mensagemIntegracao }}
              </span>
            </td>
            <td>{{ producao.dataUltimaAtualizacao }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="14">
              <div class="flex flex-column align-items-center justify-content-center py-5">
                <i class="pi pi-inbox text-4xl text-300 mb-3"></i>
                <span class="text-500 font-medium">Nenhum registro encontrado.</span>
                <span class="text-400 text-sm mt-1">Selecione uma instância e período para carregar os dados.</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Dialog de Detalhes -->
      <p-dialog
        [(visible)]="displayDetalhes"
        [modal]="true"
        [style]="{width: '600px'}"
        [draggable]="false"
        [resizable]="false"
        header="Detalhes do Registro">
        <div *ngIf="itemSelecionado">
          <div class="grid mb-3">
            <div class="col-4"><span class="text-500">Empresa:</span> <strong>{{ itemSelecionado.empresa }}</strong></div>
            <div class="col-4"><span class="text-500">Filial:</span> <strong>{{ itemSelecionado.filial }}</strong></div>
            <div class="col-4"><span class="text-500">Data:</span> <strong>{{ itemSelecionado.dataReferencia }}</strong></div>
          </div>
          <p-table [value]="itemSelecionado.itens" [paginator]="false"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [scrollable]="true" scrollHeight="20rem">
            <ng-template pTemplate="header">
              <tr>
                <th style="min-width: 150px;">Conta Contábil</th>
                <th style="min-width: 120px;">Custo Unitário</th>
                <th style="min-width: 120px;">Valor Total</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td><span class="text-sm font-medium">{{ item.contaContabil }}</span></td>
                <td class="font-semibold">{{ item.custoUnitario?.toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'}) }}</td>
                <td class="font-semibold">{{ item.valorTotal?.toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'}) }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="3" class="text-center text-500 py-3">Nenhum item encontrado.</td></tr>
            </ng-template>
          </p-table>
        </div>
        <ng-template pTemplate="footer">
          <p-button label="Fechar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="displayDetalhes = false"></p-button>
        </ng-template>
      </p-dialog>
</div>